import React, {useEffect, useRef, useState} from "react";
import {MdArrowDropDown, MdArrowDropUp, MdBarChart, MdOutlineCalendarToday,} from "react-icons/md";
import Card from "components/card";
import LineChart from "components/charts/LineChart";
import MiniCalendar from "components/calendar/MiniCalendar";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import moment from "moment/moment";
import BarChart from "../../../../components/charts/BarChart";
import PieChart from "../../../../components/charts/PieChart";
import pieChart from "../../../../components/charts/PieChart";

const UserFeedbackTrend = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let activatedDevicesCount, months
    let [resultSize, setResultSize] = useState(0)
    let [dateRange, setDateRange] = useState("This Month")
    let [momDevicesPercentage, setMomDevicesPercentage] = useState(0)
    const [presentMonthCount, setPresentMonthCount] = useState([]);
    let [refreshData, setRefreshData] = useState(true)
    let [selectedValue, setSelectedValue] = useState("Monthly")
    const [errorMessage, setErrorMessage] = useState("")
    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);
    let [open, setOpen] = useState([]);
    let [ongoing, setOngoing] = useState([]);
    let [closed, setClosed] = useState([]);
    let [totalOpen, setTotalOpen] = useState(0);
    let [totalOngoing, setTotalOngoing] = useState(0);
    let [totalClosed, setTotalClosed] = useState(0);
    let [isLoading, setIsLoading] = useState(true)
    const [pieChartDataValues, setPieChartData] = useState([]);
    const selectRef = useRef(null);

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const getDateOneMonthBefore = () => {
        const today = new Date();
        const oneMonthAgo = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate());

        // Format the date in YYYY-MM-DD format
        const formattedDate = new Intl.DateTimeFormat('en-IN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            separator: '-'
        }).format(oneMonthAgo);

        return (formattedDate.replace("/", "-"))
    };

    let [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -11));
    let [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10))

    function handleStartDateChange(lowerDate){
        setLowerDate(lowerDate)
        sessionStorage.setItem("startDate", lowerDate)
    }

    function handleEndDateChange(upperDate){
        setUpperDate(upperDate)
        sessionStorage.setItem("endDate", upperDate)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    async function getFeedbacks(dateRangeFilter) {
        setIsLoading(true)
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "4") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            var openArray = []
            var closedArray = []
            var ongoingArray = []
            totalOpen = 0;
            totalOngoing = 0;
            totalClosed = 0;
            var url = CROMPTON_ANALYTICS_URL + "v1/user/feedbacks" + dateRangeFilter + "/" + formatDateForApi(LowerDate) + "/" + handleIncreaseDate(formatDateForApi(UpperDate))

            //console.log("URL: ", url)
            await axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                setErrorMessage("")
                setResultSize(res.data.length)
                resultSize = res.data.length
                localStorage.setItem("selectedValue", dateRangeFilter)
                if (dateRangeFilter === "Daily") {
                    for (var i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            chartLabels.push((res.data[i].date))
                            openArray.push(res.data[i].open)
                            ongoingArray.push(res.data[i].ongoing)
                            closedArray.push(res.data[i].closed)
                            totalOpen = totalOpen + res.data[i].open
                            totalClosed = totalClosed + res.data[i].closed
                            totalOngoing = totalOngoing + res.data[i].ongoing
                        }
                    }
                    setDateRange("This Day")
                    /*localStorage.setItem("deviceTrendsDaily", JSON.stringify(chartLabels))
                    localStorage.setItem("activatedDevicesForLastOneYearDaily", JSON.stringify(count))*/
                }
                if (dateRangeFilter === "Weekly") {
                    for (var i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            chartLabels.push((res.data[i].week).slice(6, 9))
                            openArray.push(res.data[i].open)
                            ongoingArray.push(res.data[i].ongoing)
                            closedArray.push(res.data[i].closed)
                            totalOpen = totalOpen + res.data[i].open
                            totalClosed = totalClosed + res.data[i].closed
                            totalOngoing = totalOngoing + res.data[i].ongoing
                        }
                    }
                    setDateRange("This Week")
                    //console.log("Weeks", chartLabels)
                    /*localStorage.setItem("deviceTrendsWeekly", JSON.stringify(chartLabels))
                    localStorage.setItem("activatedDevicesForLastOneYearWeekly", JSON.stringify(count))*/
                }
                if (dateRangeFilter === "Monthly") {
                    for (var i in res.data) {
                        if (i < (Object.keys(res.data).length - 1)) {
                            chartLabels.push((res.data[i].month).slice(0, 3))
                            openArray.push(res.data[i].open)
                            ongoingArray.push(res.data[i].ongoing)
                            closedArray.push(res.data[i].closed)
                            totalOpen = totalOpen + res.data[i].open
                            totalClosed = totalClosed + res.data[i].closed
                            totalOngoing = totalOngoing + res.data[i].ongoing
                        }
                    }
                    setDateRange("This Month")
                    /*localStorage.setItem("deviceTrendsMonths", JSON.stringify(chartLabels))
                    localStorage.setItem("activatedDevicesForLastOneYearMonthly", JSON.stringify(count))*/
                }

                /*console.log(open)
                console.log(closed)
                console.log(ongoing)
                console.log(chartLabels)
                console.log(totalOpen)
                console.log(totalOngoing)
                console.log(totalClosed)*/

                setTotalOpen(totalOpen)
                setTotalClosed(totalClosed)
                setTotalOngoing(totalOngoing)

                setOpen(openArray)
                setOngoing(ongoingArray)
                setClosed(closedArray)

                open = openArray
                closed = closedArray
                ongoing = ongoingArray

                pieChartDataValues.push(totalOpen)
                pieChartDataValues.push(totalOngoing)
                pieChartDataValues.push(totalClosed)

                setPieChartData(pieChartDataValues)

                setOptions(chartLabels)
                options = chartLabels

                /*setPresentMonthCount(count[resultSize - 2])
                if(isNaN(((count[resultSize- 2] - count[resultSize - 3]) / count[resultSize - 3]) * 100)){
                    setMomDevicesPercentage(0)
                }else{
                    setMomDevicesPercentage(((count[resultSize- 2] - count[resultSize - 3]) / count[resultSize - 3]) * 100)

                }*/
                setRefreshData(false)
                setIsLoading(false)

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                setRefreshData(false)
                setErrorMessage(error.response.data.message)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
        }
    }


    useEffect(() => {

        if (selectRef.current) {
            selectRef.current.focus();
        }

        if((sessionStorage.getItem("startDate")) !== null){
            setLowerDate((sessionStorage.getItem("startDate")))
        }

        if((sessionStorage.getItem("endDate")) !== null){
            setUpperDate((sessionStorage.getItem("endDate")))
        }

        //console.log("REFRESH inside useeffect", refreshData)

        getFeedbacks(selectedValue)

        //activatedDevicesCount = JSON.parse(localStorage.getItem("activatedDevicesForLastOneYear"))

        /* setSelectedValue(localStorage.getItem("selectedValue"))
         selectedValue = localStorage.getItem("selectedValue")*/

        //handleChangeMonthDropDown()

        //console.log(selectedValue)

        /*if(selectedValue === "Daily"){
            document.getElementById("dailyData").hidden = false
            document.getElementById("weeklyData").hidden = true
            document.getElementById("monthlyData").hidden = true
        }
        if(selectedValue === "Weekly"){
            document.getElementById("dailyData").hidden = true
            document.getElementById("weeklyData").hidden = false
            document.getElementById("monthlyData").hidden = true
        }
        if(selectedValue === "Monthly"){
            document.getElementById("dailyData").hidden = true
            document.getElementById("weeklyData").hidden = true
            document.getElementById("monthlyData").hidden = false
        }*/


    }, [selectedValue, LowerDate, UpperDate])

    function handleChangeMonthDropDown() {
        const selectBox = document.getElementById("selectBoxFeedback")
        selectedValue = selectBox.options[selectBox.selectedIndex].value
        setSelectedValue(selectBox.options[selectBox.selectedIndex].value)
        getFeedbacks(selectedValue)
    }


    return (
        <Card extra="!p-[20px] text-center">
            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-navy-700 dark:text-white">
                    User Feedback Trend
                </h2>
                <div className="mb-6 flex items-center justify-center">
                    <select id="selectBoxFeedback" onChange={handleChangeMonthDropDown}
                            className="mb-3 flex items-center justify-center text-sm font-bold
                            text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white" ref={selectRef}>
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Monthly" selected>Monthly</option>
                    </select>
                </div>
            </div>

            <div className="flex justify-between">
                <h2 className="text-lg font-bold text-red-700 dark:text-white">
                    {errorMessage}
                </h2>
            </div>

            <div className="flex justify-between">
                <button
                    className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer hover:bg-gray-100 active:bg-gray-200 dark:bg-white dark:hover:opacity-90 dark:active:opacity-80">
                    <input type={"date"} id="startDate" className="datePicker" value={LowerDate}
                           onChange={(e) => handleStartDateChange(e.target.value)}/>
                    <input type={"date"} id="endDate" className="datePicker" value={UpperDate}
                           onChange={(e) => handleEndDateChange(e.target.value)}/>
                    {/*<span className="text-sm font-medium text-gray-600 react"></span>*/}
                </button>
            </div>

            <div
                className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
                <div
                    className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2 sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
                    <div className="h-[250px] w-full xl:h-[350px] xl:w-[400px] ">
                        {!isLoading &&
                            <BarChart
                                chartData={[
                                    {
                                        name: "Open",
                                        data: open,
                                        color: "#E8A09A"
                                    },
                                    {
                                        name: "Ongoing",
                                        data: ongoing,
                                        color: "#FBE29F"
                                    },
                                    {
                                        name: "Closed",
                                        data: closed,
                                        color: "#9BBFE0"
                                    }
                                ]}
                                chartOptions={{
                                    chart: {
                                        toolbar: {
                                            show: true,
                                        },
                                    },
                                    tooltip: {
                                        style: {
                                            fontSize: "12px",
                                            fontFamily: undefined,
                                            backgroundColor: "#000000"
                                        },
                                        onDatasetHover: {
                                            style: {
                                                fontSize: "12px",
                                                fontFamily: undefined,
                                            },
                                        },
                                        theme: "dark",
                                    },
                                    xaxis: {
                                        categories: options,
                                        show: true,
                                        labels: {
                                            show: true,
                                            style: {
                                                colors: "#A3AED0",
                                                fontSize: "11px",
                                                fontWeight: "500",
                                            },
                                        },
                                        axisBorder: {
                                            show: false,
                                        },
                                        axisTicks: {
                                            show: false,
                                        },
                                    },
                                    yaxis: {
                                        show: true,
                                        color: "black",
                                        labels: {
                                            show: true,
                                            style: {
                                                colors: "#CBD5E0",
                                                fontSize: "14px",
                                            },
                                        },
                                    },
                                    grid: {
                                        show: false,
                                        strokeDashArray: 5,
                                        yaxis: {
                                            lines: {
                                                show: true,
                                            },
                                        },
                                        xaxis: {
                                            lines: {
                                                show: true,
                                            },
                                        },
                                    },

                                    dataLabels: {
                                        enabled: false,
                                    },
                                    plotOptions: {
                                        bar: {
                                            borderRadius: 5,
                                            columnWidth: "80px",
                                        },
                                    },
                                }}
                            />
                        }

                    </div>
                    <div>
                        <div className="mb-auto flex h-[250px] w-full xl:h-[250px] items-center justify-center">
                            {!isLoading &&
                                <PieChart options={{
                                    labels: ["Open", "Ongoing", "Closed"],
                                    colors: ["#E8A09A", "#FBE29F", "#9BBFE0"],
                                    chart: {
                                        width: "50px",
                                    },
                                    states: {
                                        hover: {
                                            filter: {
                                                type: "none",
                                            },
                                        },
                                    },
                                    legend: {
                                        show: false,
                                    },
                                    dataLabels: {
                                        enabled: false,
                                    },
                                    hover: {mode: null},
                                    plotOptions: {
                                        donut: {
                                            expandOnClick: false,
                                            donut: {
                                                labels: {
                                                    show: false,
                                                },
                                            },
                                        },
                                    },
                                    fill: {
                                        colors: ["#E8A09A", "#FBE29F", "#9BBFE0"],
                                    },
                                    tooltip: {
                                        enabled: true,
                                        theme: "dark",
                                        style: {
                                            fontSize: "12px",
                                            fontFamily: undefined,
                                            backgroundColor: "#000000"
                                        },
                                    },
                                }
                                } series={[totalOpen, totalOngoing, totalClosed]}/>
                            }

                        </div>
                        <div className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                            <div className="flex flex-col items-center justify-center">
                                <div className="flex items-center justify-center">
                                    <div className="h-2 w-2 rounded-full bg-[#E8A09A]" />
                                    <p className="ml-1 text-sm font-normal text-gray-600">Open</p>
                                </div>
                                <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                                    { (((pieChartDataValues[0] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
                                </p>
                            </div>

                            <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

                            <div className="flex flex-col items-center justify-center">
                                <div className="flex items-center justify-center">
                                    <div className="h-2 w-2 rounded-full  bg-[#FBE29F]" />
                                    <p className="ml-1 text-sm font-normal text-gray-600">Ongoing</p>
                                </div>
                                <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                                    { (((pieChartDataValues[1] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
                                </p>
                            </div>

                            <div className="h-11 w-px bg-gray-300 dark:bg-white/10" />

                            <div className="flex flex-col items-center justify-center">
                                <div className="flex items-center justify-center">
                                    <div className="h-2 w-2 rounded-full bg-[#9BBFE0]" />
                                    <p className="ml-1 text-sm font-normal text-gray-600">Closed</p>
                                </div>
                                <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                                    { (((pieChartDataValues[2] / (pieChartDataValues[0] + pieChartDataValues[1] + pieChartDataValues[2])) * 100).toFixed(1)) + "%"}
                                </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </Card>
    );
};

export default UserFeedbackTrend;
